import { PageMenuItem } from '@components';
import { Container } from '@design-system';
import React from 'react';
import { BiSolidChat } from 'react-icons/bi';
import { FaGraduationCap, FaShoppingCart } from 'react-icons/fa';
import { FaTriangleExclamation } from 'react-icons/fa6';
import { HiClipboardDocumentList, HiMiniDocumentMagnifyingGlass } from 'react-icons/hi2';
import { IoLibrary, IoShieldCheckmarkSharp } from 'react-icons/io5';
import { PiMedalFill } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import './MenuSanteSecuritePage.scss';

export const MenuSanteSecuritePage: React.FC = () => {
    const navigate = useNavigate();

    return (
        <Container className="menu-sante-securite-page">
            <Container padding="none" row>
                <PageMenuItem
                    title="Accueil sécurité"
                    icon={<IoShieldCheckmarkSharp />}
                    onClick={() => navigate('/sante-securite/home-security')}
                    color="blue"
                />
                <PageMenuItem
                    title="Remontée d'évènement"
                    icon={<FaTriangleExclamation />}
                    onClick={() => navigate('/sante-securite/event-feedback')}
                    color="blue"
                />
                <PageMenuItem title="Causeries" icon={<BiSolidChat />} onClick={() => navigate('/sante-securite/causeries')} color="blue" />
                <PageMenuItem
                    title="Visite de sécurité"
                    icon={<HiMiniDocumentMagnifyingGlass />}
                    onClick={() => navigate('/sante-securite/security-audit')}
                    color="blue"
                />
                <PageMenuItem
                    title="PPSPS"
                    icon={<HiClipboardDocumentList />}
                    onClick={() => navigate('/sante-securite/ppsps')}
                    color="blue"
                />
                <PageMenuItem
                    title="Règles d'or"
                    icon={<PiMedalFill />}
                    onClick={() => navigate('/sante-securite/golden-rules')}
                    color="blue"
                />
                <PageMenuItem
                    title="Demande d'EPI"
                    icon={<FaShoppingCart />}
                    onClick={() => navigate('/sante-securite/epi')}
                    color="blue"
                />
                <PageMenuItem
                    title="Bibliothèque sécurité"
                    icon={<IoLibrary />}
                    onClick={() => navigate('/sante-securite/bibliotheque')}
                    color="blue"
                />
                <PageMenuItem
                    title="Module de formation"
                    icon={<FaGraduationCap />}
                    onClick={() => navigate('/sante-securite/formations')}
                    color="blue"
                />
            </Container>
        </Container>
    );
};
